/** Contains all the single projects for a section */

import React from 'react';
import ProjectTile from './ProjectTile';


class ProjectContainer extends React.Component
{
    render ()
    {
        return (
            <div className="projectContainer">
                {this.props.projectTiles.map((projectTile) => 
                    <div className="ProjectTile" key={projectTile.title}>
                        <ProjectTile 
                            img={projectTile.img} 
                            title={projectTile.title} 
                            year={projectTile.year}
                            text={projectTile.text} 
                            name={projectTile.name} 
                            component={projectTile.component}
                            project={projectTile.project}
                        />
                        <br/>
                        <br/>
                    </div>
                )}
            </div>
        );
    }
}

export default ProjectContainer;
